export default "__VITE_ASSET__Dyrl1k6h__"